import AppRouter from './router';

export default AppRouter;
